(function () {
  const submit = document.querySelector('.fee-simulation__submit');
  const url = document.querySelector('.fee-simulation__input-url');
  const pv = document.querySelector('.fee-simulation__input-pv');
  const urlValidationMsg = document.querySelector('.url-err-msg');
  const pvValidationMsg = document.querySelector('.pv-err-msg');
  const loading = document.querySelector('.fee-simulation__loading');
  const result = document.querySelector('.fee-simulation__assumption');
  const resultValue = document.querySelector('.fee-simulation__num');
  const calculationFailure = document.querySelector('.fee-simulation__calculation-failure');
  const annotation = document.querySelector('.fee-simulation__annotation');
  const pvInput = document.querySelector('.fee-simulation__input-pv');
  const urlInput = document.querySelector('.fee-simulation__input-url');
  const api = '/api/calc_requests';
  const pattern = {
    url: /^(https?|ftp)(:\/\/[\w/:%#$&?()~.=+-]+)/,
    pv: /[0-9]+/,
  };
  const regex = {
    url: new RegExp(pattern.url),
    pv: new RegExp(pattern.pv),
  };
  const validation = {
    url: false,
    pv: false,
  };
  submit.addEventListener('click', (e) => {
    e.preventDefault();
    resetAriaHidden();
    if (validateCheck()) {
      loading.setAttribute('aria-hidden', false);
      annotation.setAttribute('aria-hidden', false);
      fetch(api, {
        method: 'POST',
        body: JSON.stringify({ url: urlInput.value, pvs: parseInt(pvInput.value.replace(/,/g, ''), 10) }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (typeof data.requests === 'number') {
            resultValue.innerHTML = data.requests.toLocaleString();
            loading.setAttribute('aria-hidden', true);
            result.setAttribute('aria-hidden', false);
          } else {
            requestFailed();
          }
        })
        .catch(() => {
          requestFailed();
        });
    } else {
      resetAriaHidden();
    }
  });
  const requestFailed = () => {
    loading.setAttribute('aria-hidden', true);
    calculationFailure.setAttribute('aria-hidden', false);
    annotation.setAttribute('aria-hidden', false);
  };
  const resetAriaHidden = () => {
    loading.setAttribute('aria-hidden', true);
    result.setAttribute('aria-hidden', true);
    calculationFailure.setAttribute('aria-hidden', true);
    annotation.setAttribute('aria-hidden', true);
  };
  const validateCheck = () => {
    if (regex.url.test(url.value)) {
      validation.url = true;
      urlValidationMsg.setAttribute('aria-hidden', true);
      url.classList.remove('invalid');
    } else {
      validation.url = false;
      urlValidationMsg.setAttribute('aria-hidden', false);
      url.classList.add('invalid');
    }
    if (regex.pv.test(pv.value)) {
      validation.pv = true;
      pvValidationMsg.setAttribute('aria-hidden', true);
      pv.classList.remove('invalid');
    } else {
      validation.pv = false;
      pvValidationMsg.setAttribute('aria-hidden', false);
      pv.classList.add('invalid');
    }
    return validation.url && validation.pv;
  };
})();
